// extracted by mini-css-extract-plugin
export default {"theme-container":"ButtonPrivacyComponent_theme-container__SA5Qa","button":"ButtonPrivacyComponent_button__DjD3b"};